import styled, { css } from "styled-components";
export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow-y: scroll !important;
  scrollbar-width: none;
`;
export const MessageBubble = styled.div`
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(42, 46, 67, 0.1);
  background-color: #fff;
  padding: 20px 20px 10px 10px;
  text-align: right;
  /* max-width: 70%;
  min-width: 30%; */
  /* margin-bottom: 20px; */
  color: #2a2e43;
  display: flex;
  flex-direction: column;
`;
export const MessageUnreadBubble = styled.div`
  border-radius: 12px;
  box-shadow: 0 3px 10px 0 rgba(255, 191, 29, 0.4);
  background-color: #ffbf1d;
  padding: 20px 20px 10px 10px;
  text-align: right;
  /* max-width: 70%;
  min-width: 30%; */
  /* margin-bottom: 20px; */
  color: #2a2e43;
`;
export const DatePersianRelative = styled.div`
  text-align: left;
  margin-top: 10px;
  font-size: 10px;
  color: #2a2e43;
  opacity: 0.5;
`;
export const DatePersian = styled.div`
  text-align: left;
  margin: 0 0 5px 20px;
  font-size: 10px;
  color: #2a2e43;
`;
export const BubbleContainer = styled.div`
  width: ${({ theme }) =>
    !["xm"].includes(theme.windowWidth) ? '70%' : '90%'};
  margin-bottom: 20px;
`;

export const LinkContainer = styled.div`
border-radius: 10px;
  background-color: #2a2e43;
  color: #fff;
  text-align: center;
  margin: 5px;
  padding:5px;
  width: 50%;

`;